import { CheckCircle, Award, Shield, Clock } from "lucide-react";
import project2 from "../../assets/project-2.jpg";

const About = () => {
  const values = [
    {
      icon: Award,
      title: "Excellence",
      description: "Des standards de qualité élevés dans chaque projet",
    },
    {
      icon: Shield,
      title: "Sécurité",
      description: "Respect rigoureux des normes de sécurité sur chantier",
    },
    {
      icon: Clock,
      title: "Délais",
      description: "Engagement ferme sur le respect des échéances",
    },
  ];

  const highlights = [
    "Entreprise créée en 2015 à Bouskoura",
    "Capital social de 30 000 000 DH",
    "Parc matériel de plus de 100 engins et camions",
    "Équipe de professionnels qualifiés",
  ];

  return (
    <section
      id="apropos"
      className="section-padding bg-background relative overflow-hidden">
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-accent/30 to-transparent -z-10" />

      <div className="container-custom">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src={project2}
                alt="Projet GRAMAGEC - Campus Universitaire"
                className="w-full h-[500px] object-cover"
              />
              <div className="absolute bottom-6 left-6 right-6 bg-card/95 backdrop-blur-sm rounded-xl p-6">
                <div className="flex items-center gap-4">
                  <div className="w-16 h-16 bg-primary rounded-xl flex items-center justify-center">
                    <span className="font-heading text-2xl font-bold text-primary-foreground">
                      10+
                    </span>
                  </div>
                  <div>
                    <div className="font-heading font-bold text-lg text-foreground">
                      Années d'Expertise
                    </div>
                    <div className="text-muted-foreground text-sm">
                      Dans les travaux publics au Maroc
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-secondary rounded-2xl -z-10" />
          </div>

          <div>
            <span className="inline-block text-secondary font-semibold text-sm uppercase tracking-wider mb-4">
              À Propos de Nous
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6">
              GRAMAGEC, l'entreprise des
              <span className="text-primary"> compétences et des défis</span>
            </h2>
            <p className="text-muted-foreground text-lg leading-relaxed mb-6">
              Depuis sa création en 2015, GRAMAGEC a déployé son
              professionnalisme pour gagner la confiance de ses clients, ce qui
              lui a permis d'occuper une bonne position dans le secteur des
              travaux publics.
            </p>
            <p className="text-muted-foreground leading-relaxed mb-8">
              Forte d'une expérience de 10 ans dans le domaine, la société
              assure en permanence la réussite des projets qui lui sont confiés.
              Nos réalisations répondent aux standards en matière de qualité, de
              respect de sécurité et d'environnement.
            </p>

            <div className="grid sm:grid-cols-2 gap-4 mb-10">
              {highlights.map((item, index) => (
                <div key={index} className="flex items-center gap-3">
                  <CheckCircle className="w-5 h-5 text-secondary flex-shrink-0" />
                  <span className="text-foreground font-medium">{item}</span>
                </div>
              ))}
            </div>

            <div className="grid sm:grid-cols-3 gap-4">
              {values.map((value, index) => (
                <div
                  key={index}
                  className="bg-muted/50 rounded-xl p-4 text-center hover-lift">
                  <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mx-auto mb-3">
                    <value.icon className="w-6 h-6 text-primary" />
                  </div>
                  <h4 className="font-heading font-semibold text-foreground mb-1">
                    {value.title}
                  </h4>
                  <p className="text-muted-foreground text-xs">
                    {value.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
